export default "__VITE_ASSET__4TzZiGis__"